module.exports = __webpack_public_path__ + "88ac0683535b1412e17c8fff9e0ebb27.png";